import React, { useCallback, useContext, useRef } from 'react'
import { Col, Row, Card, Form, Container, Button } from '@themesberg/react-bootstrap'
import { Context } from '../ByWaitingTicket'

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);

  const _phone = useRef(state.filter.phone);
  const _gameId = useRef(state.filter.gameId);

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _handleChangeGame = useCallback((payload) => {
    _gameId.current = payload.target.value
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        phone: _phone.current,
        gameId: _gameId.current
      }
    })
  }, [dispatch])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>VÉ MỚI</h5>
            </Col>
            <Col className='text-right'>
              <Button style={{ marginRight: 20 }} variant="info" type="submit" onClick={_submitForm}>Tìm kiếm</Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Container>
            <Col>
              <Row className='p-1'>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Trò chơi</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Select onChange={_handleChangeGame}>
                        <option defaultValue value={''}>Chọn trò chơi</option>
                        <option value={'lotto535'}>LOTO 5/35</option>
                        <option value={'keno'}>Keno</option>
                        <option value={'mega'}>Mega 6/45</option>
                        <option value={'power'}>Power 6/55</option>
                        <option value={'max3d'}>Max3D/3D+</option>
                        <option value={'max3dpro'}>Max3D Pro</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <Col md={3} className='text-right align-self-center'>
                      <Form.Label>Số điện thoại</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control onChange={_handleChangePhone} required type="text" placeholder="Nhập số điện thoại" />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Container>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)